import request from "@/utils/request";

export default function agentBindDevice(data) {
    return request({
        url: `/device/device/agentBindDevice`,
        method: 'post',
        data
    })
}
